var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('service-introduction',{attrs:{"introductionData":_vm.introductionData,"showTab":_vm.showTab}}),_vm._m(0),_c('institutional-list',{attrs:{"institutionalListData":_vm.institutionalListData}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line"},[_c('div',{staticClass:"longLine"}),_c('div',{staticClass:"shortLine"})])
}]

export { render, staticRenderFns }